/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OverrideAnalysisResult200ResponseData } from './OverrideAnalysisResult200ResponseData';
import {
    OverrideAnalysisResult200ResponseDataFromJSON,
    OverrideAnalysisResult200ResponseDataFromJSONTyped,
    OverrideAnalysisResult200ResponseDataToJSON,
} from './OverrideAnalysisResult200ResponseData';

/**
 * 
 * @export
 * @interface GetAnalysisResultHistory200Response
 */
export interface GetAnalysisResultHistory200Response {
    /**
     * 
     * @type {Array<OverrideAnalysisResult200ResponseData>}
     * @memberof GetAnalysisResultHistory200Response
     */
    data?: Array<OverrideAnalysisResult200ResponseData>;
}

/**
 * Check if a given object implements the GetAnalysisResultHistory200Response interface.
 */
export function instanceOfGetAnalysisResultHistory200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAnalysisResultHistory200ResponseFromJSON(json: any): GetAnalysisResultHistory200Response {
    return GetAnalysisResultHistory200ResponseFromJSONTyped(json, false);
}

export function GetAnalysisResultHistory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAnalysisResultHistory200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(OverrideAnalysisResult200ResponseDataFromJSON)),
    };
}

export function GetAnalysisResultHistory200ResponseToJSON(value?: GetAnalysisResultHistory200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(OverrideAnalysisResult200ResponseDataToJSON)),
    };
}

